import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'
import Router from '@/router/index'
import global from "@/global/global.js"

let cancel;
const CancelToken = axios.CancelToken;
axios.defaults.baseURL = global.apiUrl;
axios.defaults.timeout = 300000;

//请求拦截器
axios.interceptors.request.use(config => {
	let schoolId = localStorage.getItem("schoolId");
	let Authorization = localStorage.getItem("Authorization");
	if(schoolId) config.headers['schoolId'] = schoolId;
	if(Authorization) config.headers['Authorization'] = Authorization;
	config.headers['Content-Type'] = config.params ? 'application/x-www-form-urlencoded' : 'application/json';
    return config
}, error => {
    return Promise.reject(error)
})

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    let code = +response.data.code;
    switch (code) {
        case 200:
            return response
        default:
			Message({
				message: response.data.msg,
				type: 'error'
			})
            return Promise.reject(response);
    }
}, err => {
	if(err.response.status == 401){
		Message({
			message: '登录过期，请重新登录！',
			type: 'error'
		})
		Router.push({path: '/'})
	}else{
		Message({
			message: err.response.data.msg,
			type: 'error'
		})
		return Promise.reject(err.response.data)
	}
})

export default {
	paramReq(method,url,param){
		return new Promise((resolve, reject) => {
			axios({
				method: method,
				url:url,
				params: param,
				cancelToken: new CancelToken(c => {
					cancel = c
				})
			}).then(res => {
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	},
	dataReq(method,url,param){
		return new Promise((resolve, reject) => {
			axios({
				url:url,
				method: method,
				data: JSON.stringify(param),
				cancelToken: new CancelToken(c => {
					cancel = c
				})
			}).then(res => {
				resolve(res.data);
			}).catch(err => {
				reject(err)
			})
		})
	}
}